import { c as _c } from "react/compiler-runtime";
import { postOrgSdkArgs } from '@onefootprint/fetch-hosted';
import { useMutation } from '@tanstack/react-query';
type SendResultSdkArgsRequest = {
  authToken: string;
  deviceResponse: string;
};
const sendResultSdkArgs = async (data: SendResultSdkArgsRequest) => {
  const {
    data: response
  } = await postOrgSdkArgs({
    body: {
      kind: 'verify_result_v1',
      data
    },
    throwOnError: true
  });
  return response.token;
};
const useSendResultSdkArgs = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: sendResultSdkArgs
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export default useSendResultSdkArgs;